import { reduxForm } from 'redux-form';
import Component from './EditMIDForm';
import { validate, initialValues } from './schema';

const EditMIDForm = reduxForm({
  form: 'formEditMid',
  initialValues,
  enableReinitialize: true,
  validate,
})(Component);

export default EditMIDForm;
